export const getUrlOrigin = (url) => {
  return new URL(url).origin
}
